import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { BackArrowIcon } from './BackArrowIcon';
import { PublicHeader, publicHeaderTopPaddingClass } from './PublicHeader';
import { PublicFooter } from './PublicFooter';

const sectionBody = 'space-y-10 text-slate-600 font-medium leading-relaxed';
const h2 = 'text-xl font-black text-slate-900 mb-4';
const h3 = 'text-lg font-bold text-slate-800 mb-3 mt-6';
const ul = 'list-disc pl-6 space-y-2';
const link = 'text-blue-600 font-semibold hover:underline';

export const legalStyles = { sectionBody, h2, h3, ul, link };

type LegalPageShellProps = {
  title: string;
  lastUpdated?: string;
  children: ReactNode;
};

export function LegalPageShell({ title, lastUpdated = 'May 2026', children }: LegalPageShellProps) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <PublicHeader />
      <main className={`flex-1 px-6 pb-12 ${publicHeaderTopPaddingClass} pt-8`}>
        <article className="max-w-3xl mx-auto">
          <Link
            to="/"
            className="mb-8 inline-flex items-center gap-1.5 text-sm font-bold text-blue-600 hover:underline"
          >
            <BackArrowIcon />
            Back to home
          </Link>
          <p className="text-sm text-slate-400 mb-8 italic">Last updated: {lastUpdated}</p>
          <h1 className="text-4xl font-black text-slate-900 tracking-tight mb-10">{title}</h1>
          <div className={sectionBody}>{children}</div>
        </article>
      </main>
      <PublicFooter />
    </div>
  );
}
